import React, { useState } from 'react';
import './index.css';
import api from '../../services/api_adiantamento';

export default function BuscaFornecedor(props) {

    const [fornecedores, setFornecedores] = useState([]);
    const [descricao, setDescricao] = useState('');

    function handleBuscaFornecedor() {
        api.get(`/fornecedor/?empresa=${4}&descricao=${descricao}`).then(function (response) {
            if (response.data) {
                setFornecedores(response.data);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function clickTable(event) {
        props.onSelecionar(event.target.id);
    }

    return (
        <div className="container-lg">
            <button className="btn btn-sm close" onClick={() => props.onFechar()}><span class="lnr lnr-cross"></span></button>

            <div className=" row col-md-12">

                <div className="col-md-12">
                    <label>Fornecedor:</label>
                    <div className="d-flex">
                        <input type="text" id="fornecedor" className="form-control col-md-8" value={descricao} onChange={(e) => setDescricao(e.target.value)}></input>
                        <div className="col-md-1"></div>
                        <input type="submit" value="Buscar" className="btn btn-sm btn-warning mb-2 col-md-2" onClick={() => handleBuscaFornecedor()} />
                    </div>
                </div>
                <table className="table-sm solicitacoes">
                    <thead>
                        <tr>
                            <th scope="col">ID</th>
                            <th scope="col">DESCRIÇÃO</th>
                            <th scope="col">CPF/CNPJ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            fornecedores.map(fornecedor => {
                                return (
                                    <tr className={"table mouse"} onClick={clickTable} id={fornecedor.id} key={fornecedor.id}>
                                        <td id={fornecedor.id}>{fornecedor.id}</td>
                                        <td id={fornecedor.id}>{fornecedor.descricao}</td>
                                        <td id={fornecedor.id}>{fornecedor.cpf_cnpj}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}